<div class="content">
  <pk-input-text
    id="DisplayName"
    name="DisplayName"
    [placeholder]="'Şehir Seçiniz' | translate"
    [iconName]="'pencil'"
  />
</div>
<vlc-footer-section />
